import { PAGE_TYPE, CLASSIFICATION_TYPE } from "../../../../constants";
import { eventTrackPayloadCreator } from "../../../../helpers/eventPayloadCreator";
import { EventData } from "../../../../types";
import { BasePreOrderAnalyticsPayload } from "../../../page/preorder/types";

export type ClickReturnToProductTrackEvent = BasePreOrderAnalyticsPayload;

const ClickReturnToProductAnalyticsEvent: EventData = {
  pageDetail: "Hang Tight Page",
  pageType: PAGE_TYPE.checkout,
  eventName: "Click Return To Product",
  classification: CLASSIFICATION_TYPE.coreBuyFlow,
};

export const OrderPendingClickReturnToProductEventPayload =
  eventTrackPayloadCreator<ClickReturnToProductTrackEvent>(
    ClickReturnToProductAnalyticsEvent,
  );
